<template>
    <div class="spark-screen container">
        <div class="row mx-0 mb-3">
            <div class="col pl-md-0">
                <h3 class="mb-0">{{ group ? group.name : __('Loading') }}</h3>
            </div>
        </div>

        <div class="row mx-0">
            <!-- Sidebar Navigation -->
            <div class="col-md-3 col-12 spark-settings-tabs d-none d-md-block">
                <aside>
                    <h3 class="nav-heading ml-md-0 ml-3">{{ __('Group Settings') }}</h3>
                    <ul class="nav flex-column mb-4">
                        <li class="nav-item">
                            <a class="nav-link" href="#group-profile" @click.prevent="changeTab('#group-profile')">
                                <i class="fas fa-users-cog"></i> {{ __('Group Profile') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#group-members" @click.prevent="changeTab('#group-members')">
                                <i class="fas fa-user-friends"></i> {{ __('Group Members') }}
                            </a>
                        </li>
                    </ul>
                </aside>

                <!-- @NOTE: Enable when we have a team managed integrations -->
                <!-- <aside>
                    <h3 class="nav-heading ml-md-0 ml-3">{{ __('Group Integrations') }}</h3>
                    <ul class="nav flex-column mb-4">
                        <li class="nav-item">
                            <a class="nav-link" href="#group-integrations"
                                @click.prevent="changeTab('#group-integrations')">
                                <i class="fas fa-plug"></i> {{ __('Integrations') }}
                            </a>
                        </li>
                    </ul>
                </aside> -->
            </div>

            <!-- Tab Content -->
            <div class="col-md-9">
                <div class="tab-content">
                    <!-- Group Profile -->
                    <div role="tabpanel" class="tab-pane active" id="group-profile">
                        <div class="card card-default">
                            <div class="card-header">{{ __('Group Profile') }}</div>
                            <div class="card-body">
                                <div class="alert alert-success" v-if="form.successful">
                                    {{ __('groups.profile_updated_successfully') }}
                                </div>

                                <form @submit.prevent="updateGroupProfile">
                                    <div class="form-group row">
                                        <label class="col-md-4 col-form-label text-md-right">{{ __('Group Name')
                                        }}</label>
                                        <div class="col-md-6">
                                            <input type="text" class="form-control" v-model="form.name"
                                                :class="{ 'is-invalid': form.errors.has('name') }">
                                            <span class="invalid-feedback" v-if="form.errors.has('name')">
                                                @{{ form.errors.get('name') }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="form-group row mb-0">
                                        <div class="offset-md-4 col-md-6">
                                            <button type="submit" class="btn btn-primary"
                                                @click.prevent="updateGroupProfile" :disabled="form.busy">
                                                {{ __('Update') }}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <!-- Teams in Group -->
                        <div class="card card-default mt-4">
                            <div class="card-header">{{ __('teams.teams') }}</div>
                            <div class="card-body">
                                <ul class="list-group">
                                    <li v-for="groupTeam in group.group_teams" :key="groupTeam.team.team_id"
                                        class="list-group-item">
                                        {{ groupTeam.team.name }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Group Members -->
                    <div role="tabpanel" class="tab-pane" id="group-members">
                        <div class="card card-default">
                            <div class="card-header">{{ __('Group Members') }}</div>
                            <div class="card-body">
                                <ul class="list-group">
                                    <li v-for="groupUser in group.group_users" :key="groupUser.user.id"
                                        class="list-group-item d-flex justify-content-between align-items-center">
                                        <div class="d-flex align-items-center">
                                            <img :src="groupUser.user.photo_url" alt="User Avatar"
                                                class="rounded-circle mr-2" width="40" height="40">
                                            <span>{{ groupUser.user.name }}</span>
                                        </div>
                                        <span class="badge badge-secondary">{{ labelizeGeneral(groupUser.role) }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- @NOTE: Enable when we have a team managed integrations -->
                    <!-- Group Integrations -->
                    <!-- <div role="tabpanel" class="tab-pane" id="group-integrations">
                        <group-integrations :groupId="groupId" />
                    </div> -->

                </div>
            </div> <!-- End of tab content -->
        </div> <!-- End of row -->
    </div> <!-- End of container -->
</template>

<script>
export default {
    props: ['user', 'groupId'],

    mixins: [require('/spark/resources/assets/js/mixins/tab-state')],

    data() {
        return {
            activeTab: __('Group Profile'),
            form: new SparkForm({ name: '' }),
        };
    },

    computed: {
        group() {
            const that = this;
            return this.spark.state.currentGroup;
        }
    },

    created() {
    },

    mounted() {
        this.usePushStateForTabs('.spark-settings-tabs');
    },

    methods: {

        changeTab(tabId) {
            document.querySelectorAll('.tab-pane').forEach(tab => tab.classList.remove('active'));

            const selectedTab = document.querySelector(tabId);
            if (selectedTab) {
                selectedTab.classList.add('active');
                this.activeTab = document.querySelector(`[href="${tabId}"]`)?.textContent.trim() || __('Group Profile');
            } else {
                console.warn(`Tab with ID "${tabId}" not found.`);
            }
        },

        updateGroupProfile() {
            this.form.busy = true;
            axios.put(`/api/groups/${this.groupId}/settings`, { name: this.form.name })
                .then(response => {
                    this.group = response.data;
                    Bus.$emit('updateGroup');
                    this.form.successful = true;
                    this.$toast.success(__('groups.profile_updated_successfully'));
                })
                .catch(error => {
                    this.form.errors.set(error.response.data.errors);
                    console.error('Error updating group name:', error);
                    this.$toast.error(__('groups.profile_update_failed'));
                })
                .finally(() => {
                    this.form.busy = false;
                });
        }
    }
};
</script>

<style scoped>
.spark-settings-tabs .nav-link {
    cursor: pointer;
}

.card {
    margin-bottom: 20px;
}

.rounded-circle {
    border-radius: 50%;
}
</style>
